<shared-modal-box [size]="size" [modalData]="modalData" [mobilePreserve]="mobilePreserve" class="modal-type-popup"
    positionVerticalOffset="minus">
    <shared-modal-simple-content class="modal-type-popup__content">
        <ng-content></ng-content>
    </shared-modal-simple-content>

    <shared-circle-btn class="modal-type-popup__close" (onClick)="handleCloseClick($event)" icon="close" feel="dark"
        [size]="btnCloseSize">
    </shared-circle-btn>
</shared-modal-box>